import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

export interface BillingToggleProps {
  isAnnual: boolean;
  onChange: (value: boolean) => void;
  saveLabel?: string;
  id?: string;
}

export function BillingToggle({
  isAnnual,
  onChange,
  saveLabel = "Save 20%",
  id = "billing-toggle",
}: BillingToggleProps) {
  return (
    <div className="flex items-center justify-center gap-3">
      <Label
        htmlFor={id}
        className={`text-sm ${
          !isAnnual
            ? "font-semibold text-foreground"
            : "text-muted-foreground"
        }`}
      >
        Monthly
      </Label>
      <Switch
        id={id}
        checked={isAnnual}
        onCheckedChange={onChange}
        data-testid={id}
      />
      <Label
        htmlFor={id}
        className={`text-sm flex items-center gap-2 ${
          isAnnual
            ? "font-semibold text-foreground"
            : "text-muted-foreground"
        }`}
      >
        Annually
        <span className="inline-flex items-center rounded-full bg-emerald-100 dark:bg-emerald-900/30 px-2 py-0.5 text-xs font-semibold text-emerald-700 dark:text-emerald-400">
          {saveLabel}
        </span>
      </Label>
    </div>
  );
}
